import type { IValidationResult, IValidatorParams } from "@edaz/services/baseValidationService";
import BankCodeType from "entities/bankCodeType";

export interface IsBankCodeOptions {
  codeType: (entity: any) => BankCodeType | undefined | null;
}

export function isBICCode(value = "") {
  return /^(([A-Z]|[0-9]){8}|([A-Z]|[0-9]){11})$/.test(value);
}

export function isBIKCode(value = "") {
  return /^04[0-9]{7}$/.test(value);
}

export function isAUCode(value = "") {
  return /^[0-9]{6}$/.test(value);
}

export function isFWCode(value = "") {
  return /^[0-9]{9}$/.test(value);
}

export function isCCCode(value = "") {
  return /^0[0-9]{8}$/.test(value);
}

export function isCzechBankCode(value = "") {
  return /^[0-9]{4}$/.test(value);
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export default function isBankCode(
  value: string | undefined,
  options: IsBankCodeOptions,
  params?: IValidatorParams
): IValidationResult {
  let failedConstraint = undefined;

  if (value) {
    const codeType = options.codeType(params?.entity);

    if (codeType) {
      if (codeType === BankCodeType.Bic && !isBICCode(value)) {
        failedConstraint = "bicCode";
      }

      if (codeType === BankCodeType.Bik && !isBIKCode(value)) {
        failedConstraint = "bikCode";
      }

      if (codeType === BankCodeType.Au && !isAUCode(value)) {
        failedConstraint = "auCode";
      }

      if (codeType === BankCodeType.Cc && !isCCCode(value)) {
        failedConstraint = "ccCode";
      }

      if (codeType === BankCodeType.Fw && !isFWCode(value)) {
        failedConstraint = "fwCode";
      }
    } else if (codeType === null && !isCzechBankCode(value)) {
      failedConstraint = "bankCode";
    }
  }

  if (failedConstraint !== undefined) {
    return {
      isValid: false,
      errors: {
        constraints: {
          [failedConstraint]: "false",
        },
      },
    };
  }

  return {
    isValid: true,
  };
}
